import { h } from "preact";

import style from "./style";
import BackButton from "../back-button";

const InnerPage = ({ children }) => (
  <div class={style["inner-page"]}>
    <BackButton />
    {children}
  </div>
);

export default InnerPage;
